import script from "./NetworkErrorSubmission.vue?vue&type=script&lang=ts&setup=true"
export * from "./NetworkErrorSubmission.vue?vue&type=script&lang=ts&setup=true"

import "./NetworkErrorSubmission.vue?vue&type=style&index=0&id=55248224&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55248224"]])

export default __exports__